import { combineReducers } from 'redux'
import auth from './authReducer'
import token from './tokenReducer'
import users from './usersReducer'
import admin from './adminReducer'

export default combineReducers({
    auth,
    token,
    users,
    admin
})